import { marked } from "marked";

/** Parse markdown to HTML synchronously. Use when result must be a string (e.g. before sanitizeHtml). */
export function markdownToHtml(src: string): string {
  return marked(src, { async: false }) as string;
}
